import {useLang} from 'src/app/modules/i18n/Metronici18n'
import {useAuthUser} from 'react-auth-kit'
import {useEffect} from 'react'

const ENGAMENT_URL = process.env.REACT_APP_ENGAMENT_UI_URL

export default function Engagement() {
  const lang = useLang()
  const authUser = useAuthUser()

  const currentDateTime = new Date().toISOString()

  return (
    <div className='card rounded-0 w-100 h-100'>
      <div className='h-100'>
        <iframe
          title='Promo'
          src={`${ENGAMENT_URL}/dashboard?userID=${
            authUser().id
          }&lang=${lang}&v=${currentDateTime}&token=${authUser().token}&parentUrl=${
            window.location.origin
          }&timestamp=${new Date().getTime()}`}
          width='100%'
          className='h-100 border-0'
        ></iframe>
      </div>
    </div>
  )
}
